import { supabase } from './client';

const BUCKET = 'invitation-covers';

export const storageService = {
  async uploadCoverImage(file: File, userId: string): Promise<string> {
    const ext = file.name.split('.').pop()?.toLowerCase() || 'jpg';
    const path = `${userId}/${Date.now()}.${ext}`;

    const { error } = await supabase.storage
      .from(BUCKET)
      .upload(path, file, { upsert: true });

    if (error) throw error;

    const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
    return data.publicUrl;
  },

  async deleteCoverImage(publicUrl: string): Promise<void> {
    const parts = publicUrl.split(`/storage/v1/object/public/${BUCKET}/`);
    if (parts.length < 2) return;
    const path = decodeURIComponent(parts[1]);

    const { error } = await supabase.storage.from(BUCKET).remove([path]);
    if (error) throw error;
  },
};
